import angular from "angular"
import { IReportGroup } from "./interfaces/IReportGroup"

export const vsName = 'reportingServer'
export const vsProviderName = 'reportingServerProvider'

const baseUrl = '/api/reporting'

export class ReportingServerProvider implements angular.IServiceProvider {
  private reportingGroupPromise: angular.IPromise<{ [name: string]: IReportGroup }> | undefined

  private getReportingGroupPromise($http: angular.IHttpService): angular.IPromise<{ [name: string]: IReportGroup }> {
    return $http<{ [name: string]: IReportGroup }>({
      method: 'get',
      url: baseUrl
    })
      .then((value: any) => value)
  }

  $get = ['$http', '$window', ($http: angular.IHttpService): ReportingServer => {
    const promise = this.reportingGroupPromise ?? (this.reportingGroupPromise = this.getReportingGroupPromise($http))

    return new ReportingServer(promise, $http)
  }]
}

export class ReportingServer {
  private readonly $http: angular.IHttpService
  private readonly reportGroupPromise: angular.IPromise<{ [name: string]: IReportGroup }>

  constructor(reportGroupPromise: angular.IPromise<{ [name: string]: IReportGroup }>, $http: angular.IHttpService) {
    this.reportGroupPromise = reportGroupPromise
    this.$http = $http
  }

  getReportGroup(name: string): angular.IPromise<IReportGroup | undefined> {
    return this.reportGroupPromise.then(groups => groups[name]).catch(() => undefined)
  }

  renderReportBatch(batchConfig: { batchUrl: string; reports: string[]; ids: number[] }): angular.IHttpPromise<Blob> {
    const { batchUrl, reports, ids } = batchConfig

    return this.$http<Blob>({
      method: 'post',
      url: '/api' + batchUrl,
      data: {
        Ids: ids,
        Names: reports
      },
      responseType: 'blob'
    })
  }
}